import CookieSet from 'common/util/CookieSet';
import './products-set-page.scss';

export default () =>
	Component(
		function($context) {
			return $context.select('.products-set-page');
		},
		function($page, self) {
			const set_id = $page.data('set-id');
			const update_trigger = $page.data('update-trigger');
			const set = CookieSet(set_id);

			function getCategoryId() {
				return $page.find('.products-set-page__categories').val();
			}

			function handleUpdate(e, info, set) {
				self.updateTotalCount(set.count());

				if (info.value) {
					const product_id = +info.value;
					const { action } = info;
					const $card = $(`.card[data-product-id="${product_id}"]`);
					if (!$card.length) {
						return;
					}

					$card.toggleClass('card--lightbox', action === 'remove');
				}
			}

			function handleClickDelete() {
				self.delete();
			}

			function handleChangeCategory() {
				location.href = $(this).val();
			}

			function initEventListeners() {
				$page.on('click', '.products-set-page__delete', handleClickDelete);
				$page.on('change', '.products-set-page__categories', handleChangeCategory);

				if (update_trigger) {
					$(document).on(update_trigger, handleUpdate);
				}
			}

			$.extend(self, {
				updateTotalCount: count => {
					$page.find('.products-set-page__products-total-count').html(count);
				},

				delete: () => {
					const $products = $page.find('.products-set-page__products-container');
					const product_ids = $products.data('product-ids');

					if ($.isArray(product_ids)) {
						$.each(product_ids, (idx, product_id) => {
							set.remove(product_id);
						});

						if (!getCategoryId()) {
							location.reload();
						} else {
							const url = $page
								.find('.products-set-page__categories')
								.find('option:first')
								.val();
							location.href = url;
						}
					}
				}
			});

			initEventListeners();

			return self;
		}
	);
